
import API from '@/api/api_sign'
import XInput from 'vux/src/components/x-input/index.vue'
import Group from 'vux/src/components/group/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import Loading from 'vux/src/components/loading/index.vue'
import Alert from 'vux/src/components/alert/index.vue'
import Box from 'vux/src/components/box/index.vue'
import Toast from 'vux/src/components/toast/index.vue'
import Tabbar from 'vux/src/components/tabbar/tabbar.vue'
import TabbarItem from 'vux/src/components/tabbar/tabbar-item.vue'

export default {
created(){
this.dos();
},
components: {
XInput,
XButton,
Group,
Cell,
Alert,
Loading,
XButton,
Box,
Toast,Tabbar, TabbarItem
},
data () {
return {
datas:{},
amount:''
}
},
methods: {
dos(){
API.entInfo({customerNo:this.$route.query.customerNo}).then((res)=>{
if (res.code == '000000') {
this.datas = res.data;
}else{
this.$vux.toast.show({
type:'cancel;',
text:res.msg
});
}
})
},
submit(){
console.log(this.amount);
if (this.amount == "") {
this.$vux.toast.show({
type:'cancel;',
text:'金额不能为空'
});
return;
}
let param = new FormData();
param.append("customerNo",this.datas.customerNo);
param.append("amount",this.amount);
API.entpayment(param).then((res)=>{
if (res.code == '000000') {
this.$router.push('/checkalready')
}else{
this.$vux.toast.show({
type:'cancel;',
text:res.msg
});
}
})
},

}
}



// WEBPACK FOOTER //
// ./src/pages/checkBusinessm.vue